"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var neutral = {
  100: '#FAF9F7',
  200: '#E8E6E1',
  300: '#D3CEC4',
  400: '#B8B2A7',
  500: '#A39E93',
  600: '#857F72',
  700: '#625D52',
  800: '#504A40',
  900: '#27241D'
};
var teal = {
  100: '#F0FDFF',
  200: '#C9F5F8',
  300: '#82DDE3',
  400: '#56C5CC',
  500: '#38A1A8',
  600: '#2B959C',
  700: '#1F878E',
  800: '#0F747B',
  900: '#045D62'
};
var red = {
  100: '#FFEEEE',
  200: '#FACDCD',
  300: '#F29B9B',
  400: '#E66A6A',
  500: '#D64545',
  600: '#BA2525',
  700: '#A61B1B',
  800: '#911111',
  900: '#610404'
};
var blue = {
  100: '#EBF8FF',
  200: '#D1EEFC',
  300: '#A7D8F0',
  400: '#7CC1E4',
  500: '#55AAD4',
  600: '#3994C1',
  700: '#2D83AE',
  800: '#1D6F98',
  900: '#0B4F71'
};
var yellow = {
  100: '#FFFAEB',
  200: '#FCEFC7',
  300: '#F8E3A3',
  400: '#F9DA8B',
  500: '#F7D070',
  600: '#E9B949',
  700: '#C99A2E',
  800: '#A27C1A',
  900: '#513C06'
};
var _default = {
  neutral: neutral,
  teal: teal,
  red: red,
  blue: blue,
  yellow: yellow,
  text: neutral[900],
  body: neutral[100],
  primary: teal,
  secondary: neutral[600],
  muted: neutral[400]
};
exports["default"] = _default;